import { Checkbox } from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import GeneralBloc from "../../../../bloc/general_bloc";
import RouteBloc from "../../../../bloc/route_bloc";
import UserAccessBloc from "../../../../bloc/user_access_bloc";
import HomeBloc from "../../../../bloc/home_bloc";
import Config from "../../../../Config";

import "./proposal_form.css";
import AppTextField from "../../../component/app_text_field/app_text_field";
import AppSelectField from "../../../component/app_select_field/app_select_field";
import UtilBloc from "../../../../bloc/util_bloc";
import AppModal from "../../../component/app_modal/app_modal";
import FormsBloc from "../../../../bloc/forms_bloc";
import AppLoadingDialog from "../../../dialog/app_loading_dialog";
import { isContainNumberOnly, nameValidation, numberValidation } from "../../../component/app_validation";

class CreditCardPaymentDetails extends Component {
    constructor(props) {
        super(props);
        let routeParams = RouteBloc.extractRouteParamsFromProps(props);
        this.containerRef = React.createRef();
        this.contentRef = React.createRef();
        this.state = {
            route: routeParams,
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            creditCardData: {
                cardHolderName: null,
                creditCardNo: null,
                creditCardType: null,
                creditCardExpiryDate: null,
                issueBankCode: null,
                isAuthorisedChecked: false,
                isTermsAndConditionChecked: false,
            },
            bankList: null,
            termsConditionOpen: false,
            termsConditionViewed: false,
            errorMessage: 'Fill in the required field.',
            isTermsConditionScrollToEnd: false,
            checkScrollable: false
        };
    }

    getQuotationId() {
        return this.props.match.params.itemId;
    }

    getUserDataHeader() {
        return this.state.userDataHeader;
    }
    getUserData() {
        return this.state.userData;
    }

    getEntity() {
        return this.state.route.entity;
    }

    getUserSettings() {
        return this.state.userSettings;
    }

    generateProfileSettingValue() {
        let userSettings = this.getUserSettings().info[0].value;
        let userData = this.getUserData();
        let value = userData[userSettings];
        return value;
    }

    setPropValue = () => {
        let valueobj = this.state.creditCardData;
        this.props.onChange(valueobj);
    }

    componentDidMount() {
        let userData = UserAccessBloc.getUserData();
        let userSettings = UserAccessBloc.getUserSettings();
        let name = "";
        let role = "";
        let branch = "";
        let profile = [];
        if (userData) {
            name = userData ? userData.displayName : "";
            role = userData ? userData.designationTitle : "";
            profile = userSettings ? userSettings.module.profile : [];
            this.setState({
                userData: userData,
                userDataHeader: HomeBloc.getUserData(name, role, branch),
                userSettings: profile,
            });
        }
        this.initiateData();
        this.getFormData();
    }

    initiateData() {
        let formData = this.props.value;
        let stateData = this.state.creditCardData;
        formData && Object.keys(formData).map(function (key) {
            stateData[key] = formData[key];
        })
        this.setState({ creditCardData: stateData }, () => {
            if (!UtilBloc.isNullOrEmpty(this.state.creditCardData.accHolderName) && !UtilBloc.isNullOrEmpty(this.state.creditCardData.creditCardNo) && !UtilBloc.isNullOrEmpty(this.state.creditCardData.issueBankCode)) {
                this.handleValuehange('isTermsAndConditionChecked', true);
            }
        })
    }
    async getFormData() {
        this.setState({ loading: true });
        let bankList = await FormsBloc.getBankList();
        this.setState({
            bankList: bankList.data,
            loading: false
        });
    }

    getFormFields() {
        return this.props.fields;
    }

    companyNameByEntity = () => {
        if (this.props.userGlobal) {
            switch (this.props.userGlobal.roles[0].entity) {
                case Config.entity.hsbc.code:
                    return "HSBC Amanah";
                case Config.entity.alliance.code:
                    return "Alliance Islamic Bank Berhad";
                case Config.entity.mbsb.code:
                    return "MBSB Bank Berhad";
                default:
                    return null;
            }
        }

    }

    getInitial(name) {
        let result = GeneralBloc.mergeIntoInitialName(name);
        return result;
    }

    handleScroll = (e) => {
        const bottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight <= 3;
        if (bottom) {
            this.handleValuehange('isTermsAndConditionChecked', true);
            this.setState({ termsConditionViewed: true });
        }
    }

    onValidateForm = () => {
        const { creditCardData } = this.state;
        let validated = true;
        console.log('creditCardData', creditCardData);
        Object.keys(creditCardData).map(function (key) {
            if (key == 'creditCardNo') {
                let cleanCreditCardNo = creditCardData[key]?.replace(/\s/g, '');
                validated = validated && ((UtilBloc.isContainNumberOnly(cleanCreditCardNo) && cleanCreditCardNo?.length >= 16) || false);
            } else if (key == 'accHolderName') {
                validated = validated && (!UtilBloc.nameValidation(creditCardData[key]) || false);
            }
            else {
                validated = validated && (!UtilBloc.isNullOrEmpty(creditCardData[key]) || false);
            }
            console.log('key', key, 'validated', validated);
        });
        this.setPropValidation(validated);
        this.setPropValue();
        console.log('validated', validated);
        return validated;
    }

    setPropValidation = (result) => {
        this.props.handleValidationResult(result);
    }

    handleValuehange = (field, val) => {
        let data = this.state.creditCardData;
        if (field === 'creditCardExpiryDate') {
            let date = val.replace(/[^0-9]/g, '');
            if (date.length > 2 && date[2] !== '/') {
                date = date.slice(0, 2) + '/' + date.slice(2);
                val = date;
            }
        }
        console.log("field", field, "val", val);
        data[field] = val
        this.setState({ creditCardData: data });
        this.onValidateForm();
    }

    handleNameChange(val) {
        this.setState({ name: val })
    }
    handlecreditCardNoChange(val) {
        this.setState({ creditCardNo: val })
    }
    handleBankNameChange(val) {
        this.setState({ issueBankCode: val })
    }

    handleTermsAndCondition(val) {
        if (this.state.termsConditionViewed == true) {
            this.handleValuehange('isTermsAndConditionChecked', val);
        } else {
            this.handleValuehange('isTermsAndConditionChecked', null);
        }
    }

    handleAuthorised(val) {
        this.handleValuehange('isAuthorisedChecked', val);
    }

    async handleFormSubmit() {

    }


    creditCardType() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.creditCardType}
                value={this.state.creditCardData.creditCardType}
                placeholder={'Select credit card type...'}
                options={Config.proposal.optionItem.cardType}
                onChange={(e) => { this.handleValuehange(this.getFormFields().creditCardType, e) }}
            />
        )
    }

    issueBankCode() {
        return (
            <AppSelectField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.bank}
                value={this.state.creditCardData.issueBankCode}
                fieldNames={{ label: ('reference1'), value: ('code') }}
                placeholder={'Select bank name...'}
                options={this.state.bankList}
                onChange={(e) => { this.handleValuehange(this.getFormFields().issueBankCode, e) }}
            />
        )
    }

    creditCardNo() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.creditCardNo}
                type={'credit_card'}
                placeholder={'•••• •••• •••• ••••'}
                value={this.state.creditCardData.creditCardNo}
                maxLength={19}
                // onValidate={(value) => { return (!UtilBloc.isContainNumberOnly(value) || value?.length < 7) }}
                errorMessage={numberValidation(this.state.creditCardData.creditCardNo) || 'Please enter a valid credit card number.'}
                onChange={(e) => { this.handleValuehange(this.getFormFields().creditCardNo, e) }}
            />
        )
    }

    creditCardcreditCardExpiryDate() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.creditCardExpiryDate}
                type={'text'}
                placeholder={'Enter expiry date...'}
                value={this.state.creditCardData.creditCardExpiryDate}
                maxLength={5}
                // onValidate={(value) => { return (!UtilBloc.isContainNumberOnly(value) || value?.length < 7) }}
                // errorMessage={numberValidation(this.state.creditCardData.creditCardExpiryDate) || 'Please enter a valid expiry date.'}
                onChange={(e) => { this.handleValuehange(this.getFormFields().creditCardExpiryDate, e) }}
            />
        )
    }

    name() {
        return (
            <AppTextField
                title={Config.proposal.formDataMapping.step1.creditCardPaymentFormTitle.cardHolderName}
                type={'text'}
                placeholder={'Enter account holder’s name...'}
                value={this.state.creditCardData.cardHolderName}
                onValidate={(value) => { return UtilBloc.nameValidation(value) }}
                errorMessage={nameValidation(this.state.creditCardData.cardHolderName)}
                onChange={(e) => this.handleValuehange(this.getFormFields().cardHolderName, e)}
            />
        )
    }

    termAndCondition() {
        return (
            <div className="mt-3 w-100">
                <div className="w-100">
                    <Checkbox onChange={(e) => this.handleAuthorised(e.target.checked)} checked={this.state.creditCardData.isAuthorisedChecked}>
                        I hereby authorise the bank appointed by <span style={{ fontWeight: 'bold' }}>FWD Takaful</span> to debit my credit card account for the purpose of payment of the contribution for this application.
                    </Checkbox>
                </div>
                <div>
                    <Checkbox onChange={(e) => this.handleTermsAndCondition(e.target.checked)} checked={this.state.creditCardData.isTermsAndConditionChecked}>
                        I have read and hereby accept the
                        <span
                            style={{ color: '#EE7623', cursor: 'pointer' }}
                            onClick={(e) => { e.stopPropagation(); this.setState({ termsConditionOpen: true }) }}>
                            {' '}Terms and Conditions
                        </span> for Credit Debit Card Authorisation.
                    </Checkbox>
                </div>
            </div>
        )
    }

    renderTermsAndConditionContent = () => {
        return (
            <>
                <div className="mt-4 px-3" style={{ height: '35vh', overflowY: 'scroll', scrollbarColor: '#EE7623' }} onScroll={(e) => this.handleScroll(e)} ref={this.containerRef}>
                    <div ref={this.contentRef} style={{ height: '45vh' }}>
                        <div className="quotation_privacy_policy_container d-flex">
                            <span className="quotation_privacy_policy_title">Credit Debit Card Terms and Conditions</span>
                        </div>
                        <div className='p-3'>
                            In consideration of FWD Takaful's agreement to accept my authorisation to debit my Credit/Debit Card to pay the Takaful Contribution(s) under the given Takaful Certificate number(s), I expressly agree to the following terms and conditions:
                            <ol style={{ textAlign: 'justify' }}>
                                <li className="mt-3">
                                    FWD Takaful shall determine to make the debit at initial and regular intervals within a month and shall not be held responsible for any claims, losses, damages and expenses arising from the successful or the unsuccessful processing of the debit as authorised due to exceeding credit limit, system malfunction, power failure and/or all other factors beyond FWD Takaful’s control.
                                </li>
                                <li className="mt-3">
                                    I shall resolve any problem or dispute arising from the processing of the debit with my Credit/Debit Card issuing bank as FWD Takaful is only responsible for arranging to debit my Credit/Debit Card account through the card centre as per my authorisation.
                                </li>
                                <li className="mt-3">
                                    In the event the Takaful Contribution(s) amount deducted is/are insufficient, I hereby authorise FWD Takaful to deduct the remaining amount of my Takaful Contribution(s) as specified in the Application. All paid Takaful Contribution(s) will be held under the Application until the Takaful Certificate commences, with no profit payable to me.
                                </li>
                                <li className="mt-3">
                                    I will ensure that FWD Takaful is notified in writing regarding any changes, loss, conversion or replacement of my Credit/Debit Card or cancellation of this authorisation at least one month before the next Takaful Contribution(s) is/are due, which shall only become effective after FWD Takaful has duly acknowledged receipt of my notifications.
                                </li>
                                <li className="mt-3">
                                    I hereby agree to keep FWD Takaful indemnified against any claims, loss, damage and expenses which FWD Takaful may suffer arising from my authorisation to debit my Credit/Debit Card account as aforesaid.
                                </li>
                                <li className="mt-3">
                                    Payable Takaful Contribution(s) payments will be considered as paid only upon successful processing of the debit by the card centre, and the actual receipt of the full Takaful Contribution(s) payment by FWD Takaful. The Takaful coverage shall only commence from the date of approval of the Application subject to full payment of the Takaful Contribution(s).
                                </li>
                                <li className="mt-3">
                                    FWD Takaful to use this Credit/Debit Card account only for Takaful Contribution(s) refund and no other types of payment due to me, unless FWD Takaful receives a written instruction from the Payee to revoke this instruction and the Payee provides the Direct Credit details which must be approved by FWD Takaful prior to the Takaful Contribution(s) refund effective date.
                                </li>
                                <li className="mt-3">
                                    I understand that all or part of the Takaful Contribution(s), charges and payments for this Application may be subjected to the prevailing government tax rate (if applicable), which must be paid.
                                </li>
                                <li className="mt-3">
                                    Within a reasonable period, FWD Takaful shall provide a written notice:
                                    <ol type="a">
                                        <li className="mt-3">
                                            To discontinue, interrupt, withdraw or suspend this service as it deems fit and FWD Takaful is not to be held liable for any loss or damage which may be suffered by me as a result of such action by FWD Takaful.
                                        </li>
                                        <li className="mt-3">
                                            To add, delete or amend any of the above terms and conditions from time to time. Such amendments shall become effective on such date as FWD Takaful may elect to adopt and the continued use of this service by me shall constitute my acceptance of the said amendments.
                                        </li>
                                        <li className="mt-3">
                                            To hold monies pursuant to the Takaful Contribution(s) refund due to the Payee in the event the information provided above is incorrect, incomplete and/or otherwise not possible due to no fault of FWD Takaful to successfully process this request until the new Direct Credit detail is received from me.
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    loadingContent() {
        return (
            <div style={{ height: "100%", width: "100%" }}>
                <AppLoadingDialog isLoading={this.state.loading} />
            </div>
        );
    }

    render() {
        return (
            <>
                <span style={{ color: 'red', fontStyle: 'italic', fontSize: '14px' }}>All fields are required</span>
                {this.state.loading && this.loadingContent()}
                <div className="w-100" >
                    <div className="mt-3">
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.name()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.creditCardNo()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.creditCardType()}
                            </div>
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0">
                                {this.creditCardcreditCardExpiryDate()}
                            </div>
                        </div>
                        <div className="row m-0 w-100 mt-2">
                            <div className="col-lg-6 col-sm-12 pr-3 pl-0 ">
                                {this.issueBankCode()}
                            </div>
                        </div>
                        {this.termAndCondition()}
                    </div>
                    <AppModal
                        open={this.state.termsConditionOpen}
                        handleModalClose={() => this.setState({ termsConditionOpen: false })}
                        width={'70%'}
                        title={'Credit Card Terms and Conditions.'}
                        subtitle={'Last Updated on 30 Jan 2024'}
                    >
                        {this.renderTermsAndConditionContent()}
                    </AppModal>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    userGlobal: state.user.value,
    globalFilterBy: state.filter.value,
    globalSearchBy: state.searchBy.value,
    userConfigGlobal: state.userConfig.value,
});

export default withRouter(connect(mapStateToProps)(CreditCardPaymentDetails));
